<template>
    <BreadCrumb PageTitle="Point des produits vendus" />
    <PointDesProduitsVendu />
</template>

<script lang="ts">
    import { defineComponent } from "vue";

    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import PointDesProduitsVendu from "../../components/Etats/PointDesProduitsVendu.vue";

    export default defineComponent({
        name: "PointDesProduitsVenduPage",
        components: {
            BreadCrumb,
            PointDesProduitsVendu
        },
    });
</script>